import React from "react";

export const LtiContentItemSelectionForm = (props) => {
  /* This markup is very finicky and must meet unknown (to me) LTI standards. 
    I discovered the working markup by inspecting other Canvas integrations. */
  const encodedContentItems = encodeURIComponent(
    JSON.stringify({
      "@context": "http://purl.imsglobal.org/ctx/lti/v1/ContentItem",
      "@graph": [
        {
          "@type": "LtiLinkItem",
          "@id": props.launchId,
          url: props.launchUrl,
          title: props.title,
          text: props.text,
          mediaType: "application/vnd.ims.lti.v1.ltilink",
          placementAdvice: {
            presentationDocumentTarget: "iframe",
            displayWidth: props.displayWidth,
            displayHeight: props.displayHeight,
          },
        },
      ],
    })
  );

  return (
    <form
      action={props.contentItemReturnUrl}
      method="post"
      encType="application/x-www-form-urlencoded"
    >
      <input
        type="hidden"
        name="lti_message_type"
        value="ContentItemSelection"
      />
      <input type="hidden" name="lti_version" value="LTI-1p0" />
      <input type="hidden" name="content_items" value={encodedContentItems} />
      {props.children}
    </form>
  );
};
